import { faPen, faTrash } from "@fortawesome/pro-regular-svg-icons"
import { CircularProgress } from "@mui/material"
import { translate } from "app/language/service"
import { centerMapOnCoordinateFeature } from "form/map/tools/geo-targets-coordinate"
import { GEO_TARGETS_TYPES, IFormCoordinate, IGeoTargetsListItem } from "form/model"
import { startUpdatingGeoTargetsForm } from "form/tools/geo-targets"
import { deleteCoordinate } from "form/tools/geo-targets-coordinates"
import { deleteShape } from "form/tools/geo-targets-shapes"
import { messageSVC } from "message/service"
import React from "react"
import { IGeoShape } from "shape/model"
import { FlexBox } from "ui/components/FlexBox"
import { ListActionButton } from "ui/components/main-layout/ListActionButton"

interface IGeoTargetsListActionsProps {
  item: IGeoTargetsListItem
  isDeletingSelection: boolean
}

export const GeoTargetsListActions = React.memo(
  ({ item, isDeletingSelection }: IGeoTargetsListActionsProps): JSX.Element => (
    <FlexBox
      id={`${item.id}-actions`}
      jc="start"
      gap
      fullWidth
      sx={{
        fontSize: "1.2rem"
      }}>
      {item.type === GEO_TARGETS_TYPES.COORDINATE ? (
        item?.coordinate?.isProcessingServerSide ? (
          <CircularProgress
            id={`${item.id}-processing-server-side`}
            size="small"
            sx={{ width: "1rem", height: "1rem" }}
          />
        ) : (
          <>
            <ListActionButton
              id={`${item.id}-delete-button`}
              tooltip={translate("campaign.geo-targets.coordinate.delete.title")}
              icon={faTrash}
              onClick={() =>
                messageSVC.confirmMessage({
                  addGenericConfirmMessage: true,
                  title: translate("campaign.geo-targets.coordinate.delete.title"),
                  message: translate("campaign.geo-targets.delete.confirm.message"),
                  onSuccess: () => deleteCoordinate(item.coordinate as IFormCoordinate)
                })
              }
            />
            <ListActionButton
              id={`${item.id}-update-button`}
              tooltip={translate("campaign.geo-targets.coordinate.update")}
              icon={faPen}
              isLoading={isDeletingSelection}
              disabled={isDeletingSelection}
              onClick={() => {
                centerMapOnCoordinateFeature(item.id as number)
                startUpdatingGeoTargetsForm(item.coordinate as IFormCoordinate)
              }}
              onDisabledClick={() => centerMapOnCoordinateFeature(item.id as number)}
            />
          </>
        )
      ) : (
        <ListActionButton
          id={`${item.id}-delete-button`}
          tooltip={translate("campaign.geo-targets.shape.delete")}
          icon={faTrash}
          isLoading={item?.shape?.isProcessingServerSide}
          disabled={isDeletingSelection}
          onClick={() =>
            messageSVC.confirmMessage({
              addGenericConfirmMessage: true,
              message: translate("campaign.geo-targets.shape.delete.message"),
              title: translate("campaign.geo-targets.shape.delete.title"),
              onSuccess: () => deleteShape(item.shape as IGeoShape)
            })
          }
        />
      )}
    </FlexBox>
  )
)
